import { Info, ShieldAlert, Flame, HeartPulse, KeyRound } from "lucide-react";
import { fmtDate } from "@/lib/format";

const CAT_ICON = { officer_safety: ShieldAlert, fire: Flame, ems: HeartPulse, general: KeyRound };
export const SEV_CLS = {
  critical: "border-red-500/70 bg-red-500/10 text-red-700 dark:text-red-200",
  warning: "border-amber-500/60 bg-amber-500/10 text-amber-700 dark:text-amber-200",
  info: "border-slate-500/50 bg-slate-500/10 text-slate-700 dark:text-slate-200",
};
export const STATE_CHIP = {
  active: "border-emerald-500/50 text-emerald-700 dark:text-emerald-300",
  due: "border-amber-500/60 text-amber-700 dark:text-amber-300",
  lapsed: "border-red-500/60 text-red-700 dark:text-red-300",
  inactive: "border-slate-500/40 text-slate-500",
};
export const STATE_LABEL = { active: "ACTIVE · TRUSTED", due: "DUE FOR REVIEW", lapsed: "LAPSED · UNVERIFIED", inactive: "INACTIVE" };

export function AlertRow({ a, compact = false }) {
  const Icon = CAT_ICON[a.category] || Info;
  const lapsed = a.state === "lapsed";
  return (
    <div data-testid={`location-alert-${a.id}`} className={`flex items-start gap-2 rounded-md border px-2 py-1 ${SEV_CLS[a.severity] || SEV_CLS.info} ${lapsed ? "opacity-75 border-dashed" : ""}`}>
      <Icon className={`h-3.5 w-3.5 mt-0.5 shrink-0 ${a.severity === "critical" && !lapsed ? "pulse-soft" : ""}`} />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1">
          <span className="overline-label !text-[9px] !text-current">{a.category_label}</span>
          <span className="chip mono !text-[9px] !py-0 border-current/40" data-testid={`alert-severity-${a.id}`}>{a.severity_label}</span>
          <span className={`chip mono !text-[9px] !py-0 ${STATE_CHIP[a.state]}`} data-testid={`alert-state-${a.id}`}>{STATE_LABEL[a.state]}</span>
          {!compact && <span className="mono text-[10px] opacity-80">review by {fmtDate(a.review_by)} · {a.author_name}</span>}
        </div>
        <div className="text-xs leading-snug">{a.message}</div>
      </div>
    </div>
  );
}

